import { Link, NavLink } from "react-router-dom";
import { LogOut, CreditCard, Globe } from "lucide-react";
import { toast } from "sonner";
import { storeVars, getSiteCache } from "@/lib/card";
import { siteHome } from "@/lib/siteThemes";
import { useAuth } from "@/context/AuthContext";
import BrandDialog from "@/components/BrandDialog";
import TenantBanners from "@/components/TenantBanners";

export const Brand = () => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="nav-brand-title">
    <span className="grid place-items-center w-8 h-8 rounded-md bg-gradient-to-br from-amber-300 to-amber-600 text-slate-950">
      <CreditCard size={17} strokeWidth={2.5} />
    </span>
    <span className="font-heading font-extrabold tracking-tight text-[15px]">CardForge<span className="text-amber-400">.</span></span>
  </Link>
);

const VisitWebsite = () => {
  const open = () => {
    const s = getSiteCache();
    if (s?.enabled) return window.open(siteHome(s), "_blank", "noopener,noreferrer");
    const site = storeVars()._STORE_WEBSITE.trim();
    if (!site) return toast.info("Add your website in Store profile first");
    window.open(/^https?:\/\//i.test(site) ? site : `https://${site}`, "_blank", "noopener,noreferrer");
  };
  return (
    <button onClick={open} data-testid="visit-website-button"
      className="flex items-center gap-1.5 text-xs font-semibold text-slate-950 bg-amber-400 hover:bg-amber-300 px-3 py-1.5 rounded-md transition-colors">
      <Globe size={14} /> Visit website
    </button>
  );
};

export default function AppHeader({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="sticky top-0 z-40">
    <header className="h-14 bg-slate-950/90 backdrop-blur-md border-b border-slate-800 px-5 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <Brand />
        <nav className="flex items-center gap-1">
          {[["/", "Designs", "nav-designs"], ["/cards", "Card Entry", "nav-card-entry"], ["/website", "Website", "nav-website"], ["/billing", "Plan", "nav-billing"]].map(([to, label, t]) => (
            <NavLink key={to} to={to} end data-testid={t}
              className={({ isActive }) => `px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${isActive ? "bg-slate-800 text-white" : "text-slate-400 hover:text-white"}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        {children}
      </div>
      <div className="flex items-center gap-3">
        <VisitWebsite />
        {user?.expires_at && (
          <span className="hidden md:block text-[11px] font-mono text-slate-400 px-2 py-1 rounded border border-slate-800" data-testid="header-plan-expiry">
            Plan till {new Date(`${user.expires_at}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}
          </span>
        )}
        <BrandDialog />
        <span className="text-xs text-slate-400 font-mono hidden sm:block" data-testid="header-user-email">{user?.email}</span>
        <button onClick={logout} data-testid="logout-button"
          className="flex items-center gap-1.5 text-xs text-slate-300 hover:text-white px-3 py-1.5 rounded-md border border-slate-800 hover:border-slate-600 transition-colors">
          <LogOut size={14} /> Logout
        </button>
      </div>
    </header>
    <TenantBanners />
    </div>
  );
}
